module.exports = __webpack_public_path__ + "static/media/get-it-on-google-play.e4cb19ea.svg";